module.exports = __webpack_public_path__ + "img/pic333.2a35c371.png";